import { createElement } from 'react'
import { createRoot } from 'react-dom/client'

import Gallery from './Gallery.react'

export default (el: HTMLElement) => {
	const props = JSON.parse(el.dataset.props ?? '{}')

	if (props) {
		const root = createRoot(el)
		root.render(createElement(Gallery, { ...props }))
	}
}
